const Paragraphs = ({ className = "", text, children, variant = "primary" }) => {
  const variantTypes = {
    primary: "font-[500] text-[14px] md:text-[18px] lg:text-[20px] leading-[20.44px] md:leading-[26.5px] lg:leading-[32px]",
    secondary: "font-[400] text-[16px] md:text-[18px] lg:text-[20px] leading-[17px] md:leading-[30px]",
    tertiary: "font-Apparat text-[12px] md:text-[14px] lg:text-[16px] font-[600] leading-[13.92px] md:leading-[18.50px]",
  }
  return (
    <p className={`font-Apparat tracking-[-2%] ${variantTypes[variant]} ${className}`}>
      {children ? children : text}
    </p>
  )
}
export default Paragraphs;